import React from "react";
import ReactDOM from "react-dom/client";
import "react-phone-input-2/lib/style.css";

import { Provider } from "react-redux";
import store from "./store";
import "./index.css";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <App />
  </Provider>,
);
